export default "__VITE_ASSET__Dbgtr2j2__"